import { navigate } from '@reach/router';
import { Button } from 'components/button/Button';
import { Form, Formik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAccessibilityData,
  setAccessibilityData,
} from 'reducers/accessibility';
import { closeModal, openModal } from 'reducers/modal';
import { FormRadioButtonsField } from '../../matchingProcess/matchingProcessPages/CustomFormFields/FormRadioButtonsField';
import { addClassNamesToOptions } from 'hooks/useAccessabilityColors';
import { selectWebskin } from 'reducers/auth';
import { options as accessabilityOptions } from '../../assessments/constants'

export const SJTAccessibilityModal = () => {
  const [selected, setSelected] = useState('');
  const dispatch = useDispatch();
  const accessibilityData = useSelector(selectAccessibilityData);
  const webSkinDetails = useSelector(selectWebskin);

  useEffect(() => {
    const accessibilityContainer = document.getElementsByClassName("CheckboxFieldContainer")[0] as HTMLElement;
    const radioFirstOpt = accessibilityContainer.querySelector("input[name='accessibilityChoice']:checked") as HTMLElement;
    radioFirstOpt?.focus();
  }, []);   

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const options = useMemo(
    () =>
      addClassNamesToOptions(webSkinDetails, ['', 'Yellow', 'White', 'Black']),
    [webSkinDetails]
  );

  const handleSubmit = (values: any) => {
    const { textColour, tileColour, classStr, isLight } =
      options[parseInt(values.accessibilityChoice)];
    dispatch(
      setAccessibilityData({
        textColor: textColour,
        backgroundColor: tileColour,
        titleColor: textColour,
        borderColor: textColour,
        classStr: classStr,
        errorTextColor:
          values.accessibilityChoice === '0' ? '#d83838' : textColour,
        optionNumber: parseInt(values.accessibilityChoice),
        isSet: values.accessibilityChoice === '0' ? false : true,
        isLight,
        siteAccessibilityColour: 'SiteAccessibility' + classStr,
      })
    );
    handleCloseModal();
  };

  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#36705B',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  return (
    <div className="SJTAccessibilityModal" style={modalStyle}>
      <Formik
        initialValues={{
          accessibilityChoice: accessabilityOptions.find(accessabilityOption => {
            return accessibilityData.siteAccessibilityColour?.includes(accessabilityOption.classStr)
          })?.optionId.toString() || accessibilityData.optionNumber.toString() || '',
        }}
        onSubmit={handleSubmit}
      >
        {({ isValid, isSubmitting }) => (
          <Form>
            <div className="TileRowInner">
              <FormRadioButtonsField
                fieldName={'accessibilityChoice'}
                label={''}
                options={options}
                key={`AccessibilityOptionsKey`}
              />
            </div>
            <div className="ModalFooter">
              <Button
                className="Rounded"
                priority="tertiary"
                type="button"
                onClick={handleCloseModal}
              >
                Cancel
              </Button>
              <Button
                className="Discard Rounded"
                priority="primary"
                type="submit"
              >
                Apply
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
